const lang = {
    ja: {
        'adminSettingBooth.smallZone': 'スモールブース',
        'adminSettingBooth.standardZone': 'スタンダードブース',
        'adminSettingBooth.bigZone': 'ビッグブース',
        'adminSettingBooth.grandZone': 'グランドゾーン',
        'adminSettingBooth.boothName': 'ブース名称',
        'adminSettingBooth.boothNameEN': 'ブース名称（英語）',
        'adminSettingBooth.totalImageAudio': '画像・音声の合計',
    },
};

export default lang;
